import {computed, signal} from "@preact/signals-react";
import {GROUPED_BY} from "../../../../@constants";

export const marketPositionAllData = signal({})
export const isLoadingMarketPosition = signal(false)
export const marketPositionTab = signal(GROUPED_BY.COUNTRY)

// Computed
export const marketPositionCurrentData = computed(() => marketPositionAllData.value[marketPositionTab.value] || [])